// NumberInput reports a cleared field as an empty string, which must save as a missing amount
// rather than as zero
export function recordedAmount(value: number | string | null | undefined): number | null {
  return typeof value === 'number' ? value : null;
}

export function optionalAmountValidator(label: string) {
  return (value: number | string | null) => {
    if (value == null || value === '') return null;
    return typeof value === 'number' && value >= 0
      ? null
      : `${label} must be a number (0 or greater)`;
  };
}
